var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSphinx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "194px",
    height: "187px",
    viewBox: "0 0 194 187",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Shape") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Logo_1",
    fill: "#6189ff",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M159.2,25.7 C150,17.3 139.4,10.8 127.8,6.3 C117.9,2.4 107.3,0.3 96.7,0.2 L96.6,0.2 C85.9,0.3 75.4,2.4 65.5,6.3 C53.9,10.7 43.3,17.3 34.1,25.7 C18.5,39.9 0,66.1 0,110.2 C0,112.4 1.2,114.5 3.1,115.6 C3.3,115.7 21.8,126.6 25.4,148 C27.8,162.7 37.8,173.9 54.1,180.6 C61.5,183.6 69.3,185.4 77.2,186.1 C80.6,186.3 83.6,183.7 83.8,180.3 C83.8,180.2 83.8,180 83.8,179.9 L83.8,135.8 C87.9,137 92.1,137.6 96.3,137.6 C100.7,137.6 105.2,137 109.4,135.7 L109.4,180 C109.4,183.4 112.2,186.2 115.6,186.2 L116,186.2 C123.9,185.5 131.7,183.7 139.1,180.7 C155.5,174.1 165.4,162.8 167.9,148.1 C169.5,139 173.8,130.7 180.2,124.1 C183.2,120.9 186.5,118.1 190.2,115.7 C192.1,114.6 193.3,112.5 193.3,110.3 C193.3,66.1 174.8,39.9 159.2,25.7 Z M96.6,12.7 C109.3,12.7 127.8,17.3 144.3,29.6 L133.4,50.5 L59.6,50.5 L48.9,29.7 C65.5,17.2 84,12.7 96.6,12.7 Z M37.6,146 C34.1,124.6 19.1,111.7 12.4,106.9 C13.2,72.3 26.7,50.7 39.2,38 L49.5,58.1 L49.5,84.3 C49.5,93.8 51.8,103.2 56.1,111.7 C59.7,118.8 64.9,124.9 71.3,129.6 L71.3,172.7 C60.8,170.7 40.7,164.4 37.6,146 Z M67.3,106 C63.9,99.3 62.1,91.8 62.1,84.3 L62.1,62.9 L131,62.9 L130.8,83.4 C130.8,91.2 128.9,98.8 125.5,105.8 C121.1,114.6 112.5,125.1 96.4,125.1 C79.7,125.1 71,113.2 67.3,106 Z M155.7,146 C154,156.2 147,164 134.8,169 C130.6,170.7 126.3,171.9 121.9,172.8 L121.9,129.4 C128.1,124.6 133.2,118.5 136.5,111.4 C140.8,102.7 143.1,93.2 143.1,83.5 L143.3,58.2 L154,38 C166.5,50.7 180.1,72.3 180.9,107 C174.2,111.7 159.2,124.6 155.7,146 Z",
    id: "Shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSphinx);
export default __webpack_public_path__ + "static/media/sphinx.a153f1037a2aa023fe4d10ae0d0909f1.svg";
export { ForwardRef as ReactComponent };